export default{
    surveyBuilder: {
        addNewSurvey: "Ongeza Utafiti Mpya",
        surveyTitle: "Kichwa cha Utafiti",
        surveyName: "Jina la Utafiti",
        surveyDescription: "Maelezo ya Utafiti",
        describeSurvey: "Eleza Utafiti",
        enableScheduling: "Washa Kuratibu",
        enableSchedulingInfo: "Uwezo wa kuweka tarehe au muda maalum kwa tathmini.",
        selectedDate: "Tarehe Iliyochaguliwa",
        multiStepSurvey: "Utafiti wa Hatua Nyingi",
        multiStepSurveyDetails:
          "Kulingana na idadi ya maswali katika hatua, maswali yote katika utafiti yatapangwa na kuonyeshwa kwa hatua.",
        multiStep: "Hatua nyingi",
        noQuestionEachStep: "Idadi ya maswali katika kila hatua",
        surveyStatus: "Hali ya Utafiti",
        surveyStatusDetails:
          "Utafiti unaweza kuwezeshwa tu baada ya kuongeza maswali. ",
        selectUsers: "Chagua Watumiaji",
        selectUsersDetails:
          "Ikiwa mtumiaji aliyechaguliwa amezimwa basi uchunguzi utapatikana kwa watumiaji wote. ",
        linkWithFarms: "Unganisha na Mashamba",
        linkWithFarmsDetails:
          "Ukiwezeshwa uchunguzi utaunganishwa na mashamba binafsi. ",
        enabled: "Imewashwa",
        disabled: "Imezimwa",
        cancel: "Ghairi",
        next: "Inayofuata",
        surveySettings: "Mipangilio ya Utafiti",
        selectSurveyUsers: "Chagua Watumiaji wa Utafiti",
        selectToProceed: "Tafadhali chagua watumiaji ili kuendelea",
        searchUsers: "Tafuta Watumiaji",
        usersSelected: "Watumiaji Waliochaguliwa",
        conditional: "Masharti",
        autoConditional: "Auto Masharti",
        userName: "Jina la mtumiaji",
        email: "Barua pepe",
        membershipType: "Aina ya Uanachama",
        membershipValidity: "Uhalali wa Uanachama",
        membershipRemainingDays: "Idadi ya Siku Zilizosalia",
        membershipRole: "Wajibu wa Mwanachama",
        accountProgress: "Maendeleo ya Akaunti",
        status: "Hali",
        active: "Inayotumika",
        deactivated: "Imezimwa",
        continue: "Endelea",
        questions: "Maswali",
        questionInfo: "Maandishi ya swali la tathmini litakalopelekwa kwa mhojiwa.",
        response: "Jibu",
        responses: "Majibu",
        deleteSurvey: "Futa Utafiti",
        editSurvey: "Hariri Utafiti",
        type: "Aina",
        compulsory: "Lazima",
        createSurvey: "Tengeneza Utafiti",
        surveyBuilder: "Mjenzi wa Utafiti",
        surveyList: "Orodha ya Utafiti",
        farm: "Shamba",
        responseDate: "Tarehe ya Majibu",
        viewSurvey: "Tazama Utafiti",
        question: "Swali",
        settings: "Mipangilio",
        addQuestion: "Ongeza Maswali",
        surveysSubmitted: "Tafiti Zimewasilishwa",
        surveyDetail: "Maelezo ya Utafiti",
        conditionStatus: "Hali ya Hali",
        conditionStatusDesc:
          "Watumiaji wanaolingana na masharti watastahiki utafiti kiotomatiki. ",
        endSurvey: "Maliza Uchunguzi",
        publishSurvey: "Chapisha Uchunguzi",
        copy: "Nakili",
        view: "Tazama",
        startDate: "Tarehe ya Kuanza",
        endDate: "Tarehe ya Mwisho",
        chooseDate: "Chagua Tarehe",
        select: "Chagua",
        addSurveyQuestion: "Ongeza Swali la Uchunguzi",
        editSurveyQuestion: "Badilisha Swali la Uchunguzi",
        questionScore: "Alama ya Swali",
        mandatory: "Lazima",
        yes: "Ndio",
        no: "Hapana",
        options: "Chaguo",
        typeHere: "Chapa hapa",
        typeInfo: "Menyu kunjuzi ya kubainisha aina ya ingizo linalohitajika kwa swali, kama kitufe cha chaguo, kisanduku cha tiki, au ingizo la maandishi.",
        add: "Ongeza",
        optionsHint: "Tafadhali ingiza ili kuongeza jibu au bonyeza Ongeza",
        surveyProgress: "Uchunguzi unaendelea",
        allResponses: "Muhtasari wa Majibu Yote",
        responseQuestion: "Majibu kwa Swali",
        dateSubmitted: "Tarehe ya Kusilisha",
        answer: "Majibu",
        totalScore: "Jumla ya Alama",
        score: "Alama",
        singleSelection: "Uteuzi Mmoja",
        multipleSelection: "Uteuzi Nyingi",
        if: "Ikiwa",
        then: "basi",
        noResponse: "Hakuna Majibu",
        noSurveyFound: "Hakuna Uchunguzi Uliopatikana",
        createNewSurvey:
          'Tafadhali jenga uchunguzi kwa kutumia kitufe "Jenga Uchunguzi" juu',
        cannotPublish: "Haiwezekani kuchapisha uchunguzi uliolemazwa!",
        deleteSurveyWarn:
          "Je, una uhakika unataka kufuta uchunguzi? Ikiwa utaufuta, maswali yote ya uchunguzi na majibu yatafutwa kabisa.",
        noQuestionFound: "Hakuna Maswali Yaliyopatikana",
        createQuestion:
          'Tafadhali ongeza swali kwanza kwa kutumia kitufe "ONGEZA MASWALI" juu',
        deleteQuestion: "Je, una uhakika unataka kufuta swali?",
        applyChanges: "Ungependa kutumia mabadiliko haya vipi?",
        editFutureSurveys: "HARIRI UTAFITI WA BAADAYE PIA",
        editLiveSurveyOnly: "HARIRI UTAFITI WA MOJA KWA MOJA",
        surveyIsLive:
          "Tafadhali kumbuka kuwa utafiti huu uko hai kwa sasa, na kuhariri swali wakati huu kunaweza kuathiri maoni ya awali. Ili kuepuka masuala yoyote, unaweza kufikiria kuunda nakala ya utafiti ili kufanya mabadiliko kwa maswali.",
        clickToCopy: "Bonyeza Hapa Kujenga Nakala ya Utafiti",
        applyChangesNow: "TUMIA MABADILIKO SASA",
        copySurvey: "Nakala ya Utafiti",
        changeCopySurveyName:
          "Unaweza kubadilisha jina la toleo la nakala ya utafiti.",
        checkBoxes: "Viboksi vya Kuangalia",
        fileAttachment: "Kiambatisho cha Faili",
        digitalSignature: "Saini ya Dijitali",
        clearSelection: "Futa Uchaguzi Wote",
        dynamicCrop: "Mazao Yanayobadilika",
        dynamicEquipment: "Vifaa Vinavyobadilika",
        dynamicFarmer: "Mkulima Anayebadilika",
        dynamicGeofence: "Geofence Inayobadilika",
        farmerName: "Jina la Mkulima",
        farmName: "Shamba",
        radioButton: "Kitufe cha Redio",
        scores: "Alama",
        textArea: "Eneo la Maandishi",
        textField: "Uwanja wa Maandishi",
        textFieldNumeric: "Uwanja wa Maandishi ya Nambari",
        downloadSurvey: "Pakua Utafiti",
        downloadQuestion: "Pakua Maswali Pekee",
        downloadResponse: "Pakua Majibu Yote",
        chooseFileFormat: "Chagua Umbizo la Faili",
        surveyTitleLength: "Kichwa cha utafiti kinapaswa kuwa na chini ya herufi 100",
        selectAllFiltered: "Chagua zote zilizochujwa",
        surveyDownloads: "Upakuaji wa Utafiti",
      },
    
}